import { useState } from "react";
import { FieldValues, Path, UnPackAsyncDefaultValues, useForm, UseFormProps } from "react-hook-form";
import { CommandResult } from "results/CommandResult";

export function useServerForm<TCommand extends FieldValues>(props?: UseFormProps<TCommand>) {
    const {
        register,
        handleSubmit,
        setFocus,
        setError,
        setValue,
        watch,
        control,
        reset,
        getValues,
        resetField,
        clearErrors,
        formState: { errors, dirtyFields },
    } = useForm<TCommand>(props);

    const [isSubmitting, setIsSubmitting] = useState(false);
    const [successMessage, setSuccessMessage] = useState<string>();

    const handleFailure = (result: CommandResult<unknown>) => {
        if (!result.success && result.errors) {
            for (const key in result.errors) {
                result.errors[key]?.forEach(e => {
                    const k = key as Path<UnPackAsyncDefaultValues<TCommand>>;

                    setError(k, { message: e }, { shouldFocus: true });
                });
            }
        }
    };

    return {
        register,
        handleSubmit,
        setFocus,
        setError,
        control,
        errors,
        handleFailure,
        setValue,
        reset,
        watch,
        getValues,
        isSubmitting,
        resetField,
        clearErrors,
        setIsSubmitting,
        successMessage,
        dirtyFields,
        setSuccessMessage,
    };
}
